import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';

export default function Navbar({ isAuthenticated, setShowModal }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen text-center bg-white px-4">
        <nav>
       <ul><li> <Link to="/logo"><img src={logo} alt="Logo"className="h-10 w-auto" /></Link></li><li> <Link to="/">Home</Link></li><li> <Link to="/nearby">Nearby</Link></li><li><Link to="/post">post</Link></li>
      
    
   
  

          {/* Right: Auth Button or Welcome Text */}
        
            {!isAuthenticated ? (
              <button
                onClick={() => setShowModal(true)}
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-1.5 rounded text-sm font-medium transition"
              >
                Login
              </button>
            ) : (
              <span className="text-sm text-gray-600 dark:text-gray-300">
                Welcome!
              </span>
            )}
            </ul>
            </nav>
          </div>
      
  
    
    
  );
}
